module.exports = __webpack_public_path__ + "static/20191116_170426-b1646256d063fa260b172443f7e648e7.webp";